"use strict";
/*******************************************************************************

    Contains definition for the fee of the transaction

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletTransactionFee = void 0;
var Amount_1 = require("../common/Amount");
var Types_1 = require("./Types");
/**
 * Define the interface of the fee of the transaction
 */
var WalletTransactionFee = /** @class */ (function () {
    /**
     * Constructor
     * @param tx_size The size of the transaction
     * @param medium The transaction fee for a medium speed
     * @param high The transaction fee for a high speed
     * @param low The transaction fee for a low speed
     */
    function WalletTransactionFee(tx_size, medium, high, low) {
        this.tx_size = tx_size;
        this.medium = medium;
        this.high = high;
        this.low = low;
    }
    /**
     * Returns the value specified in option among TransactionFee fees
     * @param option The fee option of wallet
     */
    WalletTransactionFee.prototype.getFee = function (option) {
        switch (option) {
            case Types_1.WalletTransactionFeeOption.High:
                return Amount_1.Amount.make(this.high);
            case Types_1.WalletTransactionFeeOption.Low:
                return Amount_1.Amount.make(this.low);
            default:
                return Amount_1.Amount.make(this.medium);
        }
    };
    return WalletTransactionFee;
}());
exports.WalletTransactionFee = WalletTransactionFee;
//# sourceMappingURL=WalletTransactionFee.js.map